import {createSlice} from "@reduxjs/toolkit";

const initialInternationalCallsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  list: null,
  data: null,
  internationalCallForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const internationalCallsSlice = createSlice({
  name: "internationalCalls",
  initialState: initialInternationalCallsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findInternationalCalls
    internationalCallsFetched: (state, action) => {
      const { totalCount, list ,data} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.list = list;
      state.data = data;
      state.totalCount = totalCount;
    },
  }
});
